import { Pipe, PipeTransform } from '@angular/core';
import { DateFormatService } from '../services/date-format.service';

@Pipe({ name: 'dateFormat', standalone: true })
export class DateFormatPipe implements PipeTransform {
  constructor(private svc: DateFormatService) {}

  transform(value: string | null | undefined): string {
    return this.svc.format(value);
  }
}
